import { get } from "lodash"
import { createSelector } from "reselect"
import { createQueryStringSelector } from "selectors/queryString"

const EMPTY_ARRAY = []
const DEFAULT_SORT_ORDER = "desc"

export const getSelectedModelId = (_, props) => get(props, "modelId")
export const getOnly = createQueryStringSelector("only")
export const getDisabled = createQueryStringSelector("disabled", EMPTY_ARRAY)
const getRawSortOrder = createQueryStringSelector("order", DEFAULT_SORT_ORDER)
export const getSortOrder = createSelector(
  [getRawSortOrder],
  (order) => ({ by: "value", order }),
)
